import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import React, { Component } from "react";
import { getFormattedImageLink } from "Utils";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import userIcon from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import calenderIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import dependentIcon from "Assets/newicons/app/profile/glyph/dependents-glyph-16px.svg";
import ScheduleActivityDrawer from "Module/Subscription/Recruit/ScheduleActivityDrawer";
import Popover from "@material-ui/core/Popover";
import IconLabel from "Component/Labels/IconLabel";
import DrawerHeader from "Component/Headers/drawerHeader";
import Drawer from "@material-ui/core/Drawer";
import classNames from "classnames";
import { instance } from "Actions/AxiosInstance";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import crossIcon from "Assets/newicons/action/close-x/outline/close-x-outline-16px.svg";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import moment from "moment";

const GetNumberOfEmp = (count) => {
  if (count >= 3) {
    return count - 3;
  }
  return 0;
};

class Activity extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onCloseDrawer = () => {
    this.setState({ drawerOpen: false });
    this.props.closeActivity();
  };

  handleChange = (index, value, key) => {
    const { activityList } = this.props;
    activityList[index][key] = value;
    this.setState({ activityList });
  };

  onSave() {
    const { activityList } = this.state;
    const data = activityList.filter((x) => x.checked);
    this.props.enqueueSnackbar(
      "Are you sure  you have completed these activities ?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              // const { selectedRow } = this.state;
              this.props.closeSnackbar();
              instance
                .post("recruit/updateactivitystatus", {
                  activitystatusid: 3,
                  activityids: data.map((x) => x.activityid),
                })
                .then((result) => {
                  this.onCloseDrawer();
                  this.props.enqueueSnackbar("Saved successfully", {
                    variant: "success",
                  });
                })
                .catch((error) => {
                  // postData = JSON.parse(backData);
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() =>
              this.setState({ createmenu: false }, () =>
                this.props.closeSnackbar(),
              )
            }
          >
            No
          </Button>,
        ],
      },
    );
  }

  render() {
    const { classes } = this.props;
    const { activityFlag, activity_anchorEl } = this.props;
    return (
      <div>
        <Popover
          open={activityFlag}
          anchorEl={activity_anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          // onClick={() => this.props.closeActivity()}
          // className="margin-top-8"
          style={{ background: "rgba(0,0,0,0.5)" }}
          classes={{
            paper: "activity-paper",
          }}
        >
          <div style={{ width: 368, padding: 24 }}>
            <div
              className="margin-bottom-16 display-flex"
              style={{ justifyContent: "space-between" }}
            >
              <p className="small-dark t-bold">Activities</p>
              <div className="display-flex">
                {((this.props.selectedrow &&
                  this.props.selectedrow.isrecruiter) ||
                  (this.props.selectedrow &&
                    this.props.selectedrow.ishiringowner) ||
                  (this.props.selectedrow &&
                    this.props.selectedrow.ishiringmanager)) && (
                  <p
                    className="small-blue t-bold cursor-pointer margin-right-8"
                    onClick={() =>
                      this.setState({ drawerOpen: true, activityFlag: false })
                    }
                  >
                    + Schedule activity
                  </p>
                )}
                <span
                  className="cursor-pointer"
                  onClick={() => this.props.closeActivity()}
                >
                  <img src={crossIcon}></img>
                </span>
              </div>
            </div>

            <div>
              {this.props.activityList && this.props.activityList.length > 0 ? (
                <div>
                  {this.props.activityList.map((item, index) => (
                    <div className="display-flex margin-bottom-16">
                      <div>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value: item.activitystatusid == 3 || item.checked,
                            placeholder: "",
                            label: "",
                            disabled:
                              this.props.selectedrow &&
                              (this.props.selectedrow.isrecruiter ||
                                this.props.selectedrow.ishiringowner ||
                                this.props.selectedrow.ishiringmanager)
                                ? false
                                : true,
                          })}
                          onChange={(value) => {
                            this.handleChange(index, value, "checked");
                          }}
                        />
                      </div>
                      <div className="margin-top-2">
                        <span>
                          <IconLabel
                            label={item.title}
                            img={userIcon}
                            labelClassNames="t-14 t-bold"
                            className="margin-bottom-8"
                          />
                          <IconLabel
                            label={`Activity start on ${moment(
                              item.activitystart,
                            ).format("YYYY-MM-DD")}`}
                            img={calenderIcon}
                            className="margin-bottom-8"
                          />

                          <Grid container>
                            <div
                              className="avtar-thumb-wrapper-small"
                              style={{ height: 20, marginLeft: 8 }}
                            >
                              {item.participant &&
                              item.participant.length > 0 ? (
                                item.participant.map((emp) => (
                                  <Tooltip
                                    key="key"
                                    title={emp.employeename || emp.fullname}
                                    placement="bottom"
                                  >
                                    <div
                                      className={
                                        GetNumberOfEmp(
                                          item.participant.length,
                                        ) > 0
                                          ? "avtar-thumb-blur"
                                          : "avtar-thumb"
                                      }
                                      style={{
                                        height: 20,
                                        width: 20,
                                        marginLeft: -12,
                                      }}
                                    >
                                      <Link
                                        to={`./profile/${emp.employeeid}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div
                                          className="avatar-wrapper-small"
                                          style={{ height: 20 }}
                                        >
                                          {emp.imagepath == null ? (
                                            <img
                                              src={DefaultProfileImage}
                                              height="20"
                                              className="team-avatar"
                                            />
                                          ) : (
                                            <img
                                              src={getFormattedImageLink(
                                                emp.imagepath,
                                              )}
                                              height="20"
                                              className="team-avatar"
                                            />
                                          )}
                                        </div>
                                      </Link>
                                    </div>
                                  </Tooltip>
                                ))
                              ) : (
                                <div style={{ marginLeft: -8 }}>
                                  <p
                                    className="extra-small-dark-secondary"
                                    style={{ paddingTop: 6 }}
                                  >
                                    No Employee Assigned
                                  </p>
                                </div>
                              )}
                            </div>
                            {item.participant && item.participant.length > 0 ? (
                              GetNumberOfEmp(item.participant.length) > 0 ? (
                                <div
                                  // className="additional-count"
                                  style={{
                                    marginTop: 3,
                                    height: 20,
                                    width: 20,
                                    marginLeft: 8,
                                  }}
                                >
                                  <span>
                                    <div
                                      // className="total-count-small"
                                      style={{ top: 4 }}
                                    >
                                      +{GetNumberOfEmp(item.participant.length)}
                                    </div>
                                  </span>
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </Grid>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="small-dark-secondary">
                  No activities scheduled. You can schedule activity by clicking
                  "+Schedule activity" button
                </p>
              )}
              {this.props.activityList &&
                this.props.activityList.filter((x) => x.checked).length > 0 && (
                  <Button
                    color="primary"
                    variant="contained"
                    className="btn btn-primary-md-blue"
                    onClick={this.onSave.bind(this)}
                  >
                    Save
                  </Button>
                )}
            </div>
          </div>
        </Popover>
        <Drawer
          anchor="right"
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false,
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer padding16"),
          }}
        >
          <DrawerHeader
            header="Schedule activity"
            isbackarrow={false}
            closeDrawer={() => this.onCloseDrawer()}
          />
          <ScheduleActivityDrawer
            {...this.state}
            {...this.props}
            onCloseDrawer={this.onCloseDrawer}
            getData={this.props.getData}
          />
        </Drawer>
      </div>
    );
  }
}

export default withSnackbar(Activity);
